export const modelsSelector = state => state.models;



// WEBPACK FOOTER //
// ./src/store/reducers/models/selectors.js